import React from 'react';

import { cn } from '@lyearn/style';
import { LinearProgress, Stack, Typography } from '@lyearn/ui';

import { backgroundTransparent, progressbarStyles } from './styles';
import { JobStatusItemProps } from './types';

const overrides = {
  borderRadius: { left: 'rounded-none', right: 'rounded-none' },
  trackColor: backgroundTransparent,
  transition: progressbarStyles,
};

const JobStatusItem: React.FC<JobStatusItemProps> = (props) => {
  const { className, rightNode, title, description, leftNode, progress, onMouseOut, onMouseOver } =
    props;

  return (
    <Stack
      alignItems="center"
      className={cn(
        'relative mt-12 overflow-hidden rounded-16 border border-divider py-20 shadow-01 pe-32',
        className,
      )}
      justifyContent="between"
      onMouseOut={onMouseOut}
      onMouseOver={onMouseOver}>
      <Stack alignItems="center" className="ms-24">
        {leftNode}
        <Stack className="ms-24" direction="col" gapY={2}>
          <Typography color="text-text-primary" variant="label-01">
            {title}
          </Typography>
          <Typography color="text-text-secondary" variant="body-short-02">
            {description}
          </Typography>
        </Stack>
      </Stack>
      {rightNode}
      <LinearProgress
        className="absolute bottom-0 w-full flex-shrink-0"
        color="success"
        overrides={overrides}
        size="x-small"
        value={progress}
      />
    </Stack>
  );
};

export default JobStatusItem;
